module.exports = __webpack_public_path__ + "static/img/bye_bye.16a25b6e.png";